import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { initialAsyncReduxState } from '../../constants';
import {
    defaultOccupationFilterValues,
    defaultOccupationOverview,
    OccupationFilterValues,
    OccupationOverview,
} from '../../models/OccupationOverview/OccupationOverview';
import { Pagination } from '../../models/Pagination';
import { AsyncReduxState } from '../../types';

export type OccupationOverviewState = AsyncReduxState<{
    activeFilterValues: OccupationFilterValues;
    occupationOverview: OccupationOverview;
    pagination?: Pagination;
}>;

const initialState: OccupationOverviewState = {
    ...initialAsyncReduxState,
    activeFilterValues: defaultOccupationFilterValues(),
    occupationOverview: defaultOccupationOverview(),
};

export const occupationOverviewSlice = createSlice({
    name: 'occupationOverviewReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): OccupationOverviewState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): OccupationOverviewState {
            return {
                ...state,
                error: action.payload,
            };
        },
        setActiveFilterValues(state, action: PayloadAction<OccupationFilterValues>): OccupationOverviewState {
            return {
                ...state,
                activeFilterValues: action.payload,
            };
        },
        setOccupationOverview(state, action: PayloadAction<OccupationOverview>): OccupationOverviewState {
            return {
                ...state,
                occupationOverview: action.payload,
            };
        },
        setPagination(state, action: PayloadAction<Pagination>): OccupationOverviewState {
            return {
                ...state,
                pagination: action.payload,
            };
        },
    },
});

export const {
    setIsLoading,
    setError,
    setActiveFilterValues,
    setOccupationOverview,
    setPagination,
} = occupationOverviewSlice.actions;

export default occupationOverviewSlice.reducer;
